
<template>
  <div class="adspirit-advertising">
    <v-container no-gutters class="pt-0 pb-0">
      <v-row justify="center">
        <v-col cols="12" class="pa-0">
          <ins
            class="asm_async_creative adsprit-container"
            style="display: block; width:100%; text-align: left; text-decoration: none;"
            data-asm-cdn="cdn.adspirit.de"
            data-asm-host="bfv.adspirit.de"
            data-asm-responsive="1"
            :data-asm-params="asmParams"
          ></ins>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: "AdSpiritAdvertising",
  data: function () {
    return {
      loadListener: undefined,
    };
  },
  props: {
    pid: {
      type: String,
      default: '14'
    }
  },
  mounted: function () {
    if (window.asm_async_data) {
      Vue.nextTick(() => {
        this.initAdspirit()
      });
    } else {
      let me = this
      this.loadListener = function () {
        // console.log('page is fully loaded', event);
        me.initAdspirit()
      }
      this.loadListener = window.addEventListener('load', this.loadListener);
    }
  },
  destroyed: function() {
    // console.log('ad spirit advertising destroyed')
    if (this.loadListener) {
      window.removeEventListener('load', this.loadListener)
    }
  },
  computed: {
    asmParams: function () {
      let routeName = this.$route.name
      var ret = 'pid=' + this.pid + '&responsive=1'
      ret += '&gdpr=0'
      // TODO: ret += + '&gdpr_consent=[consentstring]'
      if (this.$store.state.isLoggedIn) {
          // Add targeting
          var tgt = '' // e.g. 207830069 (fix length)
          if (this.$store.state.profile && this.$store.state.profile.sex) {
            if (this.$store.state.profile.sex == 'm') {
              tgt += '1'
            } else if (this.$store.state.profile.sex == 'f') {
              tgt += '2'
            } else {
              tgt += '0';
            }
          } else {
            tgt += '0' // sex: 0=unknown, 1=male, 2=female
          }
          if (this.$store.state.profile.acat) {
            var ageStr = '' + this.$store.state.profile.acat
            while(ageStr.length < 3) {
              ageStr = '0' + ageStr
            }
            tgt += ageStr
          } else {
            tgt += '000' // Age (000 = unknown, age + 47 = Age known)
          }
          tgt += '0' // Income, 0 = unknown
          tgt += '0000' // Interests see https://support.adspirit.de/hc/de/articles/360016393631-Nutzerprofil-Targeting
          ret += '&tgt=' + tgt
      }
      if (routeName) {
        ret += '&view=' + routeName
      }
      return ret
    }
  },
  methods: {
    initAdspirit() {
      window.asm_async_data.initi()
    }
  },
};
</script>
<style scoped>
</style>
